import t, { getExampleNumber as a, getCountries as m, getCountryCallingCode as u, isValidPhoneNumber as l } from "libphonenumber-js";
import i from "libphonenumber-js/examples.mobile.json";
import { FORM_VALID as s } from "../Form/Form.constant.js";
import { formatErrorMessage as N } from "../Form/Form.helpers.js";
const h = (r) => {
  const e = t(r);
  return e ? e.country : "";
}, P = (r, e) => {
  const o = t(r, e), n = o ? o.format("E.164") : "";
  return n.startsWith("+") ? n : r;
}, g = (r, e) => {
  const o = t(r, e);
  return o ? o.formatNational() : "";
}, d = (r) => {
  const e = a(r, i);
  return e ? e.formatNational() : "";
}, C = (r, e) => (e || m()).map((o) => ({
  dial: `+${u(o)}`,
  label: r ? r(o) : o,
  value: o
})).sort((o, n) => o.label.localeCompare(n.label)), y = (r, e) => {
  const o = t(r, e) || {
    country: "",
    countryCallingCode: "",
    formatInternational: () => "",
    formatNational: () => ""
  };
  return {
    country: o.country,
    dial: `+${o.countryCallingCode}`,
    internationalNumber: o.formatInternational(),
    nationalNumber: o.formatNational()
  };
}, E = (r, e) => {
  if (r && e) {
    const o = t(e, {
      defaultCallingCode: r.replace("+", "")
    });
    return o ? o.format("E.164") : "";
  }
  return "";
};
function x(r) {
  return (e, o, n) => typeof e == "string" && (e === "" || l(e)) ? s : N(r, e, o, n);
}
export {
  h as getCountryCodeFromPhoneNumber,
  C as getCountryOptions,
  d as getNationalPhoneNumberExample,
  P as getPhoneNumberAsE164,
  g as getPhoneNumberAsNational,
  y as getPhoneNumberInfos,
  E as getPhoneNumberToE164,
  x as validPhoneNumber
};
